/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright (c) 2026 Steven Warehouse Project. All Rights Reserved.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration - loaded from environment variables
// For redirect flow (signInWithRedirect):
// - Local dev: Use Firebase's authDomain (firebaseapp.com)
//   Firebase handles the OAuth flow and redirects back to localhost:5173
//   The redirectChecked state in AuthContext ensures proper handling
// - Production: Use custom domain with auth proxy that forwards to Firebase
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.DEV
    ? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN   // steven-warehouse-dev.firebaseapp.com
    : window.location.hostname,                    // insights.steven.com for production
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');

export default app;
